// extracted by mini-css-extract-plugin
module.exports = {"metadataPackageTitle":"styles_metadataPackageTitle__BP3wo"};